/* eslint-disable no-restricted-globals */
import { pluralize } from './textHelper';

export const getDateInToEpoch = (dateString) => {
  if (dateString) return new Date(dateString).getTime();
  return null;
};

const getOrdinal = (num) => {
  if (num > 3 && num < 21) return 'th';
  switch (num % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

// Aug
export const getMonthString = (date, type = 'short') =>
  new Date(date).toLocaleString('default', { month: type });

// 1942
export const getYear = (date) => new Date(date).getFullYear();

// 5
export const getDay = (date, withOrdinal = false) => {
  const day = new Date(date).getDate();
  return withOrdinal ? `${day}${getOrdinal(day)}` : day;
};

const fromToDate = (s, e) => {
  const startsAt = new Date(s);
  const endsAt = new Date(e);
  if (endsAt.getFullYear() === startsAt.getFullYear)
    return `${startsAt.toLocaleString('default', {
      month: 'short'
    })} ${startsAt.getDate()} - ${endsAt.toLocaleString('default', {
      month: 'short'
    })} ${endsAt.getDate()}, ${endsAt.getFullYear()}`;
  return `${startsAt.toLocaleString('default', {
    month: 'short'
  })} ${startsAt.getDate()}, ${startsAt.getFullYear()} - ${endsAt.toLocaleString(
    'default',
    {
      month: 'short'
    }
  )} ${endsAt.getDate()}, ${endsAt.getFullYear()}`;
};

// 5th Aug
export const getDateMonthString = (date, full = false, withOrdinal = true) => {
  const month = getMonthString(date, full ? 'long' : 'short');
  const dateInMonth = getDay(date, withOrdinal);
  return `${dateInMonth} ${month}`;
};

// Aug 5
export const getDateShort = (d, short = true) => {
  const date = new Date(d);
  return `${date.toLocaleString('default', {
    month: short ? 'short' : 'long'
  })} ${date.getDate()}`;
};

// Aug 5, 2020
export const getFullDate = (d) =>
  d ? `${getDateShort(d)}, ${getYear(d)}` : 'N/A';

// 5 August, 2020
const getFullDateWithDayAtStart = (d, long = true) =>
  `${getDay(d)} ${getMonthString(d, long ? 'long' : 'short')}, ${getYear(d)}`;

const startofWeek = (d) => {
  const date = new Date(d);
  const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
  return new Date(date.setDate(diff));
};

// 3:30 PM
const getTime = (d, laterInMins) => {
  let date;
  if (laterInMins)
    date = new Date(new Date(d).getTime() + laterInMins * 60 * 1000);
  else date = new Date(d);
  const h = date.getHours();
  let m = date.getMinutes();
  if (m < 10) m = `0${m}`;
  return `${h % 12 || 12}:${m} ${h < 12 ? 'A' : 'P'}M`;
};

// 3:05
const getTimeWithoutAmPm12HrFormat = (d) => {
  const date = new Date(d);
  const h = date.getHours();
  let m = date.getMinutes();
  if (m < 10) m = `0${m}`;
  return `${h % 12 || 12}:${m}`;
};

const getAmPm = (d) => {
  const date = new Date(d);
  const h = date.getHours();
  return h < 12 ? 'AM' : 'PM';
};

// Aug 5, 3:30 PM
const dateWithTime = (d) => {
  if (!d) return '';
  const date = new Date(d);
  return `${getDateShort(date)}, ${getTime(date)}`;
};

// Aug 5, 2020, 3:30 PM
export const fullDateWithTime = (d, separator = ', ') => {
  if (!d) return 'N/A';
  const date = new Date(d);
  return `${getFullDate(d)}${separator}${getTime(date)}`;
};

const getStartAndEndDateOfWeek = (d, lessons, quizes) => {
  if (!d) return null;
  const date = new Date(d);
  const tempDate = new Date(date);
  const monday = startofWeek(tempDate);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  let infoString = '';
  if (monday.getMonth() === sunday.getMonth())
    infoString = `${monday.toLocaleString('default', {
      month: 'short'
    })} ${monday.getDate()} - ${sunday.getDate()}`;
  else
    infoString = `${monday.toLocaleString('default', {
      month: 'short'
    })} ${monday.getDate()} - ${sunday.toLocaleString('default', {
      month: 'short'
    })} ${sunday.getDate()}`;
  if (lessons) infoString += ` • ${lessons} lesson${lessons > 1 ? 's' : ''}`;
  if (lessons && quizes) infoString += ', ';
  if (!lessons && quizes) infoString += ' • ';
  if (quizes) infoString += ` ${quizes} quiz${quizes > 1 ? 'es' : ''}`;
  return infoString;
};

const getStartAndEndDateofCourseWithCount = (
  date1,
  date2,
  lessons,
  quizzes,
  isTestSeries
) => {
  if (!date1 || !date2) return '';
  let infoString = `${getDateShort(date1)} - ${getDateShort(date2)}`;
  if (lessons) infoString += ` • ${lessons} lesson${lessons > 1 ? 's' : ''}`;
  if (lessons && quizzes) infoString += ', ';
  if (!lessons && quizzes) infoString += ' • ';
  if (isTestSeries && quizzes)
    infoString += ` ${quizzes} test${quizzes > 1 ? 's' : ''}`;
  else if (quizzes) infoString += ` ${quizzes} quiz${quizzes > 1 ? 'es' : ''}`;
  return infoString;
};

// e.g 3:01 pm Gives time in 12 hr format with am/pm
export const formatTime = (d) => {
  if (!d) return '';
  const date = new Date(d);
  const h = date.getHours();
  let m = date.getMinutes();
  if (m < 10) m = `0${m}`;
  return `${h % 12 || 12}:${m} ${h < 12 ? 'A' : 'P'}M`;
};

// e.g. 5h 16m
export const getTimeFormatInShortFormWithoutSecs = (
  timeInSeconds,
  h = 'h',
  m = 'm'
) => {
  if (timeInSeconds == null) return '';
  if (timeInSeconds <= 0) return '0s';
  const seconds = Math.floor(timeInSeconds);
  const hrs = Math.floor(seconds / 3600);
  const min = Math.floor((seconds - 3600 * hrs) / 60);
  let hoursText = `${hrs}${h} `;
  if (hrs === 0) hoursText = '';
  let minText = `${min}${m} `;
  if (min === 0) minText = '';
  return hoursText + minText;
};

export const getTimeFormatInShortFormWithSecs = (
  timeInSeconds,
  h = 'h',
  m = 'm',
  s = 's'
) => {
  if (timeInSeconds == null) return '';
  if (timeInSeconds <= 0) return '0s';
  const seconds = Math.floor(timeInSeconds);
  const hrs = Math.floor(seconds / 3600);
  const min = Math.floor((seconds - 3600 * hrs) / 60);
  let hoursText = `${hrs}${h} `;
  if (hrs === 0) hoursText = '';
  let minText = `${min}${m} `;
  if (min === 0) minText = '';
  let secText = `${seconds}${s} `;
  if (seconds === 0) secText = '';
  return hoursText + minText + secText;
};

const getTimeFormatInShortFormWithoutSecsFromMins = (
  timeInMins,
  showSeconds = false,
  h = 'h',
  m = 'm',
  secs = 'secs'
) => {
  if (timeInMins == null) return '';
  if (timeInMins <= 0) return '0s';
  const hrs = Math.floor(timeInMins / 60);
  const min = Math.floor(timeInMins - 60 * hrs);
  const seconds = Math.floor((timeInMins - Math.floor(timeInMins)) * 60);
  let hoursText = `${hrs} ${h} `;
  if (hrs === 0) hoursText = '';
  let minText = `${min} ${m} `;
  if (min === 0) minText = '';
  let secText = `${seconds} ${secs}`;
  if (seconds === 0) secText = '';
  return `${hoursText}${minText}${showSeconds && hrs === 0 ? secText : ''}`;
};

const getMinutesValueFromSeconds = (value) => {
  if (value == null || value <= 0) return '';
  const minutes = Math.floor(value / 60);
  const min = minutes + (minutes === 1 ? ' min' : ' mins');
  return min;
};

// eg x sec = ahym (3800s === 1h 3m // 3m)
const getHoursMinutesValueFromSeconds = (value) => {
  if (value == null || value <= 0) return '0m';
  const seconds = Math.floor(value);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - 3600 * hours) / 60);
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

// e.g. 1:18 min
const formatMinutesFromSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${
    remainingSeconds > 9 ? remainingSeconds : `0${remainingSeconds}`
  } mins`;
};

export const timeInMinsSecs = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins > 0 && !isNaN(mins) ? `${mins}m` : ''} ${
    // eslint-disable-next-line no-nested-ternary
    isNaN(secs) ? '0' : secs > 9 ? secs : `0${secs}`
  }s`;
};

export const compareDates = (date1, date2) => {
  if (!date1 || !date2) return null;
  const d1 =
    typeof date1.getTime === 'function'
      ? date1.getTime()
      : new Date(date1).getTime();
  const d2 =
    typeof date2.getTime === 'function'
      ? date2.getTime()
      : new Date(date2).getTime();
  if (d1 === d2) return 0;
  if (d1 < d2) return 1;
  if (d1 > d2) return -1;
};

export const addTime = (date, timeAdd, unit = 's') => {
  if (date && timeAdd) {
    const timeDiff = {
      s: 1000,
      m: 60000,
      h: 60 * 60000,
      d: 24 * 60 * 60000,
      yr: 365 * 24 * 60 * 60000
    };
    return new Date(date.getTime() + timeAdd * timeDiff[unit]);
  }
  return date;
};

const isSameDay = (dateToCheck, actualDate) =>
  dateToCheck.getDate() === actualDate.getDate() &&
  dateToCheck.getMonth() === actualDate.getMonth() &&
  dateToCheck.getFullYear() === actualDate.getFullYear();

export const timeAgoSinceDate = (date, full = true) => {
  // seconds value
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const year = month * 12;
  const secondsDiff = Math.floor(
    (Date.now() - new Date(date).getTime()) / 1000
  );
  if (secondsDiff < minute) return 'just now';
  let valueWithLabel;
  if (secondsDiff < hour)
    valueWithLabel = {
      value: secondsDiff / minute,
      label: full ? 'minute' : 'm'
    };
  else if (secondsDiff < day)
    valueWithLabel = {
      value: secondsDiff / hour,
      label: full ? 'hour' : 'h'
    };
  else if (secondsDiff < month)
    valueWithLabel = {
      value: secondsDiff / day,
      label: full ? 'day' : 'd'
    };
  else if (secondsDiff < year)
    valueWithLabel = {
      value: secondsDiff / month,
      label: full ? 'month' : 'mo'
    };
  else
    valueWithLabel = {
      value: secondsDiff / year,
      label: full ? 'year' : 'y'
    };
  if (full) {
    return `${pluralize(
      Math.floor(valueWithLabel.value),
      valueWithLabel.label
    )} ago`;
  }
  return `${Math.floor(valueWithLabel.value)}${valueWithLabel.label} ago`;
};

export const getDateRange = (initial, final) => {
  if (!initial || !final) return '';
  const initialDate = new Date(initial);
  const finalDate = new Date(final);
  const initialMonth = getMonthString(initialDate);
  const finalMonth = getMonthString(finalDate);
  const initialYear = getYear(initialDate);
  const finalYear = getYear(finalDate);
  const isDiffYear = initialYear !== finalYear;
  const isDiffMonth = isDiffYear || initialMonth !== finalMonth;
  return `${getDay(initialDate)} ${
    isDiffMonth ? getMonthString(initialDate) : ''
  }${
    isDiffYear ? `, ${getYear(initialDate)}` : ''
  } - ${getFullDateWithDayAtStart(finalDate, false)}`;
};

// lastDate == should be in epoch and less than current date
export const getDaysLapsed = (lastDate) => {
  if (!lastDate) return 0;
  const d1 = new Date(lastDate).getTime();
  const current = new Date().getTime();
  return Math.floor((current - d1) / (1000 * 3600 * 24));
};

export const getMinutesDifferenceBetweenDates = (futureDate, currentDate) => {
  const diffInMilliseconds = futureDate - currentDate;
  const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
  return diffInMinutes;
};

export default {
  fromToDate,
  getDateShort,
  getMonthString,
  getDateMonthString,
  getStartAndEndDateOfWeek,
  formatTime,
  getTimeFormatInShortFormWithoutSecs,
  getTimeFormatInShortFormWithoutSecsFromMins,
  getStartAndEndDateofCourseWithCount,
  getMinutesValueFromSeconds,
  formatMinutesFromSeconds,
  dateWithTime,
  compareDates,
  getYear,
  getDay,
  addTime,
  timeAgoSinceDate,
  isSameDay,
  timeInMinsSecs,
  getFullDate,
  getTime,
  getDateInToEpoch,
  getTimeWithoutAmPm12HrFormat,
  getAmPm,
  getHoursMinutesValueFromSeconds,
  fullDateWithTime,
  getFullDateWithDayAtStart,
  getDateRange,
  getDaysLapsed,
  getMinutesDifferenceBetweenDates
};
